<template>
        <a  v-if="getCompareItemById" v-on:click="removeCompareItem"
            href="javascript:void(0)" class="add-to-confirm added">
            <i v-if="short_view" class="add-to-confirm-icon added"></i>
            <span v-else>{{toCompareTitle}}</span>
        </a>
        <a v-else v-on:click="addItemToCompare"
           href="javascript:void(0)" class="add-to-confirm">
            <i v-if="short_view" class="add-to-confirm-icon"></i>
            <span v-else>{{inCompareTitle}}</span>
        </a>
</template>

<script>
    import {mapGetters} from 'vuex';
    import _u from "jsAssets/utils/index";

    /**
     * Компонент для отображения и изменения принадлежности товара к списку сравнения.
     *
     * Для работы необходимо передать Id товара к которому относится компонент
     *
     * @vuedoc
     * @module vue:components/MiniCompare
     * @exports vue:components/MiniCompare
     */

    export default {
        name: "compare-catalog-item",

        components: {
        },

        props: [
            'product_id', 'to_compare_title','in_compare_title','short_view'
        ],

        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {string} inCompareTitle - Название кнопки когда товар в сравнениях
         * @property {string} toCompareTitle - Название кнопки когда товар отсутствует в сравнениях
         * @property {string|int} productId - Id товара за который отвечает компонент
         */
        data() {
            return {
                productId : this.product_id,
                inCompareTitle: this.to_compare_title,
                toCompareTitle: this.in_compare_title,
            }
        },

        computed: {
            ...mapGetters('compare', [
                'compareItems',
            ]),

            /**
             *  Вычисляемое свойство которое в зависемости от Id товара определяет его принадлежность
             *  к товарам в списке сравнения
             *
             * @method getCompareItemById
             */
            getCompareItemById() {

                if(this.compareItems && this.compareItems[this.productId] !== 'undefined') {
                    let data = this.compareItems[this.productId];
                    return data >= 0;
                }
                return false;
            },

        },

        mounted(){
        },

        methods: {
            /**
             *  При нажатии на кнопку идет запрос к серверу на добавление товара в список сравнения
             *
             * @method addItemToCompare
             */
            addItemToCompare(){
                this.$store.dispatch('compare/addItemToCompare',this.productId);
            },
            /**
             *  При нажатии на кнопку идет запрос к серверу на удаления товара с списока для сравнения
             *
             * @method removeCompareItem
             */
            removeCompareItem(){
                this.$store.dispatch('compare/removeCompareItem',this.productId);
            },
        }
    }


</script>
